import { NavLink, Outlet } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { cn } from '@/lib/utils';

const TABS = [
  { to: 'library',       label: 'Library' },
  { to: 'chapters',      label: 'Chapters' },
  { to: 'assignments',   label: 'Assignments' },
  { to: 'quizzes',       label: 'Quizzes' },
  { to: 'announcements', label: 'Announcements' },
  { to: 'audit',         label: 'Sync Audit' },
  { to: 'sources',       label: 'Connections' },
];

export function KnowledgeBaseLayout() {
  return (
    <div className="p-6">
      <PageHeader title="Knowledge Base" />

      <div
        role="tablist"
        aria-label="Knowledge base sections"
        className="mb-4 flex flex-wrap gap-1 border-b border-slate-200"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            role="tab"
            className={({ isActive }) =>
              cn(
                'shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap',
                'transition-colors duration-150',
                isActive
                  ? 'text-blue-600 border-b-2 border-blue-600 -mb-px'
                  : 'text-slate-500 hover:text-slate-700 border-b-2 border-transparent -mb-px',
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
